import { Injectable } from '@angular/core';
import { strings } from '../resources/strings';

@Injectable()
export class ResourceService
{
    public constructor()
    {

    }

    public getString(key: string, fallback: string = ''): string
    {
        return strings[key] || fallback || 'MISSING: ' + key;
    }
}
